"use strict";

var _interopRequireWildcard3 = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));

var _react = _interopRequireWildcard3(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _customProps = require("../../../../utils/customProps");

var _Storyblok = _interopRequireDefault(require("../../../../utils/Storyblok"));

var _customComponents = require("../../../../utils/customComponents");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var AccordionSummary = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require('./components/AccordionSummary/AccordionSummary'));
  });
});
var AccordionDetails = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require('./components/AccordionDetails/AccordionDetails'));
  });
});

var Accordion = function Accordion(_ref) {
  var rootClass = _ref.rootClass,
      accordionDetails = _ref.accordionDetails,
      accordionSummary = _ref.accordionSummary,
      defaultExpanded = _ref.defaultExpanded,
      width = _ref.width,
      dataBlokC = _ref.dataBlokC,
      dataBlokUid = _ref.dataBlokUid,
      storyblokClass = _ref.storyblokClass;

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass, {
    width: width
  });

  var _useState = (0, _react.useState)(defaultExpanded),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var handleChange = function handleChange() {
    return setExpanded(!expanded);
  };

  var panelSummary = accordionSummary[0];
  var panelDetails = accordionDetails[0];
  return /*#__PURE__*/_react.default.createElement(_core.Accordion, {
    expanded: expanded,
    onChange: handleChange,
    className: "".concat(styles.root, " ").concat(storyblokClass),
    "data-blok-c": dataBlokC,
    "data-blok-uid": dataBlokUid
  }, /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)
  }, (0, _customComponents.renderComponentsWithBridge)({
    AccordionSummary: AccordionSummary
  }, _objectSpread({}, panelSummary))), /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)
  }, (0, _customComponents.renderComponentsWithBridge)({
    AccordionDetails: AccordionDetails
  }, _objectSpread({}, panelDetails))));
};

var _default = Accordion;
exports.default = _default;
Accordion.propTypes = {
  /** stroyblok multiselect of css classes */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /** if true pannale is expanded on load */
  defaultExpanded: _propTypes.default.bool,

  /** width of panel */
  width: function width(props, propName, componentName) {
    return (0, _customProps.dimensionProp)(props, propName, componentName);
  },

  /** AccordionSummary Allowed maximum: 1 */
  accordionSummary: function accordionSummary(props, propName, componentName) {
    var components = ['AccordionSummary'];
    return (0, _customProps.validComponentsRequired)(props, propName, componentName, components, 1);
  },

  /** AccordionDetails Allowed maximum: 1 */
  accordionDetails: function accordionDetails(props, propName, componentName) {
    var components = ['AccordionDetails'];
    return (0, _customProps.validComponentsRequired)(props, propName, componentName, components, 1);
  },

  /** storyblok prop for when in editor to allow click bridge */
  dataBlokC: _propTypes.default.string,

  /** storyblok prop for when in editor to allow click bridge */
  dataBlokUid: _propTypes.default.string,

  /** storyblok prop for when in editor to allow click bridge */
  storyblokClass: _propTypes.default.string
};
Accordion.defaultProps = {
  width: '100%',
  defaultExpanded: false,
  rootClass: [],
  accordionSummary: [],
  accordionDetails: [],
  dataBlokC: '',
  dataBlokUid: '',
  storyblokClass: ''
};